import editorCommonOptions from './editor-common-options.graphql';
import editorCommon from './editor-common.graphql';
import editorGroupService from './editor-group-service.graphql';
import editorInputSchema from './editor-input-schema.graphql';
import editorLayoutSchema from './editor-layout-schema.graphql';


const editorSchema = [editorLayoutSchema, editorInputSchema, editorGroupService, editorGroupService, editorCommon, editorCommonOptions].join('\n');

export { editorSchema };


